import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { processGoogleCallback } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // Extract session_id from hash — handle multiple formats
    const hash = window.location.hash;
    let sessionId = null;

    // Try URLSearchParams approach first (handles #session_id=xxx and #key=val&session_id=xxx)
    try {
      const params = new URLSearchParams(hash.substring(1));
      sessionId = params.get("session_id");
    } catch {}

    // Fallback: regex extraction
    if (!sessionId) {
      const match = hash.match(/session_id=([^&]+)/);
      if (match) sessionId = match[1];
    }

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    // Clear the hash to prevent re-processing on refresh
    window.history.replaceState(null, "", window.location.pathname);

    (async () => {
      try {
        await processGoogleCallback(sessionId);
        navigate("/dashboard", { replace: true });
      } catch (err) {
        console.error("[AuthCallback] Google callback failed:", err);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, processGoogleCallback]);

  return (
    <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full bg-[#2D6A4F] animate-breathe mx-auto mb-4" />
        <p className="text-[#78857F] font-['Figtree']" data-testid="auth-callback-loading">Signing you in...</p>
      </div>
    </div>
  );
}
